(function () {
  if (window.__hebsCarouselInit) return;
  window.__hebsCarouselInit = true;

  function initCarousel(root) {
    if (!root || root.dataset.hebsReady === 'true') return;

    const track = root.querySelector('[data-hebs-track]');
    const slides = Array.from(root.querySelectorAll('[data-hebs-slide]'));
    const prevBtns = root.querySelectorAll('[data-hebs-prev]');
    const nextBtns = root.querySelectorAll('[data-hebs-next]');
    const dots = Array.from(root.querySelectorAll('[data-hebs-dot]'));
    const autoplay = root.dataset.autoplay === 'true';
    const interval = parseInt(root.dataset.autoplayInterval, 10) || 6000;

    if (!track || slides.length === 0) return;

    let index = 0;
    let timer = null;
    let touchStartX = 0;
    let touchDeltaX = 0;

    function goTo(i, { animate = true } = {}) {
      index = (i + slides.length) % slides.length;
      track.style.transition = animate ? 'transform 0.45s cubic-bezier(0.25, 0.1, 0.25, 1)' : 'none';
      track.style.transform = 'translateX(-' + index * 100 + '%)';

      slides.forEach((slide, idx) => {
        slide.setAttribute('aria-hidden', idx === index ? 'false' : 'true');
        slide.tabIndex = idx === index ? 0 : -1;
      });

      dots.forEach((dot, idx) => {
        dot.setAttribute('aria-selected', idx === index ? 'true' : 'false');
        dot.classList.toggle('hebs__dot--active', idx === index);
      });

      root.setAttribute('data-hebs-active', index);
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || slides.length < 2) return;
      timer = setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    prevBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        stopAutoplay();
        prev();
        startAutoplay();
      });
    });

    nextBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        stopAutoplay();
        next();
        startAutoplay();
      });
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        stopAutoplay();
        goTo(i);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    root.addEventListener(
      'keydown',
      (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          stopAutoplay();
          prev();
          startAutoplay();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          stopAutoplay();
          next();
          startAutoplay();
        }
      },
      true
    );

    const viewport = root.querySelector('[data-hebs-viewport]');
    if (viewport) {
      viewport.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
          touchDeltaX = 0;
          stopAutoplay();
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        (e) => {
          touchDeltaX = e.changedTouches[0].screenX - touchStartX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        () => {
          if (Math.abs(touchDeltaX) > 50) {
            if (touchDeltaX < 0) next();
            else prev();
          }
          startAutoplay();
        },
        { passive: true }
      );
    }

    goTo(0, { animate: false });
    startAutoplay();
    root.dataset.hebsReady = 'true';
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-hebs-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:reorder', () => boot());
})();
